import React, { useEffect, useState } from 'react';
import { getUserDocId } from '../../Localstorage';
import { fetchEnrollCourses, fetchEnrollUnit } from '../../Firebase/Course-fb';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../Css/Home.css'
import { calculateTimeUntilEndOfYear, formatTimestampToDate, msToHM, sortData } from '../../Helper/Calculation';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from '../../Localstorage';
import Datanotfound from '../../Helper/Datanotfound';
import Notfound from '../../Images/Logo/NotFound.png'

const Enrollcourse = ({
    accessCard, accessEnrollCourse, handleClick
}) => {
    const [enrolled, setEnrolled] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const handleEnrollUnit = async (enroll_unit,subject_code,access_till) => {
        if(new Date(access_till) > new Date){
            const filteredEnrollUnit = (enrolled.filter(item => item.subject_code === subject_code))[0]?.unit_code_list;
            const unit = await fetchEnrollUnit(enroll_unit);
            const topic_filter = sortData(unit);
            accessCard();
            accessEnrollCourse();
            handleClick(null);
            navigate('/enroll-topic', { state: {topic_filter,filteredEnrollUnit} })
        }
    }

    const fetchCourseData = async () => {
        try {
            const userId = await getUserDocId();
            const course = await fetchEnrollCourses(userId);
            console.log("enroll = ",course)

            if (Array.isArray(course) && course.length > 0) {
                setEnrolled(course[0].course_list);
            } else {
                console.warn("No enrolled courses found!");
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchCourseData();
    }, []);

    return (
        <div className='Enroll_course_container'>
            <h3>Enrolled Courses</h3>
            <div className='Enroll_course_inner_container'>
                {loading ? (
                    <>
                        <div className='Enroll_course_card'>

                            <Skeleton width={60} height={60} baseColor="#ddd" highlightColor="#f3f3f3" borderRadius={0} />

                            <div>
                                <span><Skeleton baseColor="#ddd" highlightColor="#f3f3f3" className='enroll-load-one' /></span>
                                <br />
                                <span><Skeleton baseColor="#ddd" highlightColor="#f3f3f3" className='enroll-load-two' /></span>
                            </div>
                        </div>

                        <div className='Enroll_course_card'>

                            <Skeleton width={60} height={60} baseColor="#ddd" highlightColor="#f3f3f3" borderRadius={0} />

                            <div>
                                <span><Skeleton baseColor="#ddd" highlightColor="#f3f3f3" className='enroll-load-one' /></span>
                                <br />
                                <span><Skeleton baseColor="#ddd" highlightColor="#f3f3f3" className='enroll-load-two' /></span>
                            </div>
                        </div>

                        <div className='Enroll_course_card'>

                            <Skeleton width={60} height={60} baseColor="#ddd" highlightColor="#f3f3f3" borderRadius={0} />

                            <div>
                                <span><Skeleton baseColor="#ddd" highlightColor="#f3f3f3" className='enroll-load-one' /></span>
                                <br />
                                <span><Skeleton baseColor="#ddd" highlightColor="#f3f3f3" className='enroll-load-two' /></span>
                            </div>
                        </div>
                    </>
                ) : enrolled.length === 0 ? (
                    <div className="enroll_notfound">
                        <img src={Notfound} alt="No Data Found" />
                    </div>
                ) : (
                    enrolled.map((item, index) => (
                        <div key={index} onClick={() => handleEnrollUnit(item.unit_code_list,item.subject_code,item.access_till)}>
                            <div className='Enroll_course_card'>
                                <div>
                                    <img src={item?.subject_image} alt="Course" />
                                </div>
                                <div>
                                    <span className='Enroll-topic'>{item?.subject_name}</span>
                                    <br />
                                    <span>Subscription Type: {item?.access_type}</span>
                                    <br />
                                    <span className='enrol-validity'>Validity: {formatTimestampToDate(item.access_till)}</span>
                                    <div className="red-dot" style={{ backgroundColor: new Date(item.access_till) > new Date() ? "#00C000" : "red" }}></div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default Enrollcourse;
